import { Form } from "react-bootstrap"
import { CurriculumQuestion, TopicStudentAnswers, CurriculumSection } from "shared/types/curriculumTypes"
import styles from "../../../components/Lessons/LessonModule/styles.module.scss"
import assignmentStyles from "../../../components/Assignment/assessment.module.scss"
import OpenCanvasButton from "components/Assignment/components/OpenCanvasButton"

interface SectionQuestionInputProps {
    question: CurriculumQuestion
    sectionNumber: number
    studentAnswers: TopicStudentAnswers
    initialStudentAnswers: TopicStudentAnswers
    currentSection: CurriculumSection
    handleAnswerChange: (sectionNum: number, questionsNum: number, answer: string, drawingResponse: string, updateInitialState?: boolean) => void
}

export default function SectionQuestionInput({ question, sectionNumber, studentAnswers, initialStudentAnswers, currentSection, handleAnswerChange }: SectionQuestionInputProps) {

    if (!question) {
        return null
    }

    if (question.answers?.length > 1) {
        return <>{question?.answers?.map((answer, answerIndex) => (
            <div
                key={answerIndex}
                className={`${assignmentStyles.answerOption} text-start`}
            >
                <input
                    type="radio"
                    id={`s${sectionNumber}-q${question.sortOrder}a${answerIndex}`}
                    name={`s${sectionNumber}-q${question.sortOrder}`}
                    value={answer.letter}
                    checked={studentAnswers[`s${sectionNumber}-q${question.sortOrder}`]?.answer === answer.letter}
                    onChange={() => {
                        handleAnswerChange(sectionNumber, question.sortOrder, answer.letter, null)
                    }}
                />
                <label htmlFor={`s${sectionNumber}-q${question.sortOrder}a${answerIndex}`} className="ms-1">
                    <span className='me-2'>{answer.letter}.</span>
                    <span dangerouslySetInnerHTML={{ __html: answer.answer }} />
                </label>
            </div>
        ))}</>
    } else if (question.type === "Drawing") {
        return <OpenCanvasButton
                questionType="topic"
                question={{...question, sectionNumber: currentSection.sortOrder}}
                initialTopicDrawingData={initialStudentAnswers?.[`s${currentSection.sortOrder}-q${question.sortOrder}`]}
                handleAnswerChange={handleAnswerChange}
            />
    } else if (question.type === "Table") {
        return null
    } else {
        return <Form.Control
            as="textarea"
            className={`${styles.lessonInput} input-glow ms-auto`}
            name={`s${sectionNumber}-q${question.sortOrder}`}
            value={studentAnswers[`s${sectionNumber}-q${question.sortOrder}`]?.answer}
            onChange={(e) => handleAnswerChange(sectionNumber, question.sortOrder, e.target.value, null)}
        />
    }
}
